import { Component, OnInit, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {DateAdapter} from '@angular/material/core';
import {TranslateService} from 'ng2-translate/ng2-translate';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';
import {ModalUploadComponent} from '../../modal-upload/modal-upload.component';
import * as decode from 'jwt-decode';
import {DatePipe} from '@angular/common';

import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

import { saveAs } from 'file-saver/FileSaver';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-consignments',
  templateUrl: './consignments.component.html',
  styleUrls: ['./consignments.component.scss']
})
export class ConsignmentsComponent implements OnInit {
  @ViewChild('fileInvView', { static: false }) fileInvView;
  userId: any;
  userToken: any;
  temp = [];
  load = true;
  data: any = {};
  typeFileUpload: any;
  step = 0;
  tot = 0;
  totalSelect = 0;
  loadBtn = false;
  listSocieties = [];
  listPlanta = [];
  listPlantaSel =[];
  checkedAll = true; //false;

  listOc = [];
  listSend=[];

  providersList=[];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;

  // listOc = [
  //   {id: 13, material: 500986543022, material_Documento: 'Material 1', cantidad: 13, unidad_Medida: 'PZ', importe: 300, date: '2018-05-25', moneda: 'MXN'},
  //   {id: 13, material: 500986543027, material_Documento: 'Material 2', cantidad: 66, unidad_Medida: 'PZ', importe: 250, date: '2018-03-22', moneda: 'MXN'},
  //   {id: 13, material: 500986543013, material_Documento: 'Material 3', cantidad: 57, unidad_Medida: 'PZ', importe: 1300, date: '2018-03-22', moneda: 'MXN'},
  //   {id: 13, material: 500986543025, material_Documento: 'Material 4', cantidad: 8, unidad_Medida: 'PZ', importe: 3300, date: '2018-03-22', moneda: 'MXN'}
  // ];
  perfilId;
  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, public translate: TranslateService, private provService: ProvidersService, private adapter: DateAdapter<any>) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    this.perfilId = tokenPayload.IdPerfil;
    gralService.changeTextHead('CONSIGNMENT');
    console.log(this.perfilId)
    translate.onLangChange.subscribe(lang => {
      if(lang.lang == 'en'){
        this.adapter.setLocale('en-GB');
      }

      if(lang.lang == 'es'){
        this.adapter.setLocale('es-MX');
      }
    });
    this.getSocieties();
    this.getPlantas();
  }

  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    this.data.end = new Date();
    this.data.init = new Date(2020, 8, 1);
    this.data.currency = 'USD';
    this.data.provider = '';

  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  addProveedorSearch(option){
    let proveedor = option.split(' - ');
    console.log(proveedor[1]);
    this.data.provider = proveedor[0];
    this.myControl.setValue(proveedor[0]);
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.selectSociety();
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(){
    const society = this.listSocieties.find(x => x.NoSociedad == this.data.society);
    if(society.NumProveedor){
      this.data.provider = society.NumProveedor;
    }

    this.listPlantaSel = this.listPlanta.filter(x => x.IdSociedad == society.IdSociedad || x.IdSociedad  == 0 );
    this.data.Plant = null;
  }


  getPlantas(){
    this.provService.getPlantas(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listPlanta = data['Entidades'];

      }else{
        this.listPlanta = null;
      }
    }, (err) => {

      this.loadBtn = false;
      this.listPlanta = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectPlanta(index){

    const planta = this.listPlanta[index];
    if(planta.NoPlanta){
      this.data.Plant = planta.NoPlanta;
    }
  }

  disabledProv(){
    let resp = false;
    if(this.data.society){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.society);
      if(society.NumProveedor){
        resp = true;
      }
    }
    return resp;
  }


  search(){
    if(!this.data.init ||
      !this.data.end ||
      !this.data.currency ||
      !this.data.society ||
      !this.data.provider
      /*||
      !this.data.Plant*/  ){
      this.toastr.error('Favor de ingresar todos los datos', 'Error');
      return;
    }

    this.loadBtn = true;
    const datePipe = new DatePipe('en-US');
    const params = 'fechaInicial='+datePipe.transform(this.data.init, 'dd-MM-yyyy')+
      '&fechaFinal='+datePipe.transform(this.data.end, 'dd-MM-yyyy')+
      '&moneda='+this.data.currency+
      '&sociedad='+this.data.society+
      '&numeroProveedor='+this.data.provider +
      ( this.data.Plant ? '&planta=' + this.data.Plant : "" );

    this.provService.searchConsignments(params, this.userToken).then((data) => {
      this.loadBtn = false;

      if(data['listaConsignacion'].length > 0){
        this.listOc = data['listaConsignacion'];
        this.temp = data['listaConsignacion'];
        this.step = 1;
        this.reorderDataExportExcel();
        const check = {
          checked:true
        }
        this.selectAll(check);
      } else {
        this.listOc = null;
        this.temp = null;
        this.toastr.info('No existen resultados disponibles', 'Consignación');
      }
    }, (err) => {
      console.log(err);
      this.step = 0;
      this.listOc = null;
      this.temp = null;
      this.loadBtn = false;
      this.toastr.error(err['message'], 'Error');
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectAll(event){
    let tot = 0;
    console.log(" console "+event.checked);
    for(let g = 0; g < this.listOc.length; g++){
      this.listOc[g].select = event.checked;
      tot += this.listOc[g].importe;
    }
    tot = event.checked == true ? tot : 0;
    this.tot = tot;
    this.totalSelect = tot;
  }


  
  sumTot(event,linea){
    let data;
    data = this.listOc.find(x => x.num_linea == linea);
    data.select = event.checked;
    if(event.checked){      
      this.tot += data.importe;
    }else{
      this.tot -= data.importe;
    }
    /*for(let g = 0; g < this.listOc.length; g++){
      if(this.listOc[g].select){
        tot += this.listOc[g].importe;
      }
    }*/
    this.totalSelect = this.tot;
  }

  getTotal(){
    let tot = 0;
    for(let g = 0; g < this.listOc.length; g++){
      tot = tot+this.listOc[g].importe;
    }
    return tot;
  }

  uploadFiles(type){
    let objSend = [];
    for(let g = 0; g < this.listOc.length; g++){
      if(this.listOc[g].select){
        objSend.push(this.listOc[g]);
      }
    }

    const params = {
      IdUsuarioSeleccion: this.userId,
      xmlBase64: null,
      pdfBase64: null,
      numeroProveedor: this.data.provider,
      claveEmpresa: 'SMP',
      tipoOrden: 6,
      sociedad: this.data.society,
      planta: this.data.Plant,
      moneda: this.data.currency,
      fecha_ini: this.data.init,
      fecha_fin: this.data.end,
      datosConsignacion: objSend,
    };

    const dialogRef = this.dialog.open(ModalUploadComponent, {
      minWidth: '70%',
      position: {
        top: '6%'
      },
      data: { type: type, data: params, totalSelect: this.totalSelect }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.data = {};
        this.step = 0;
        this.listOc = null;
        this.temp = null;
      }
    });
  }

  CreateListToSend(){
    let lista = this.listOc;
    for(let i = 0; i < lista.length; i ++ ){

    }

  }


  //  Excel //

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExcel);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('consignacion'));
  }

  listExcel =  [];
  reorderDataExportExcel(){
    this.listExcel =  [];
    let lista = this.listOc;
    for(let i = 0; i < lista.length; i++){


      let params = {
          "Doc material": lista[i].material_Documento,
          "Fecha doc" :   lista[i].fecha_Documento,
          "Material":     lista[i].material,
          "Descripción":  lista[i].MAKTX,
          "Cantidad" :    lista[i].cantidad,
          "UM":           lista[i].unidad_Medida,
          "Importe":      lista[i].importe ,
          "Moneda":       lista[i].moneda
      }
      this.listExcel.push(params);
    }
  }


}
